import React from 'react';

export default function DomainBrandLogo({ src, alt = 'OnTest', ...props }) {
  const branding = window.OnTestDomainBranding || { name: 'OnTest', isOnTest: true };
  if (branding.isOnTest) return <img src={src} alt={alt} {...props} />;
  return <span aria-label={branding.name} style={{
    display: 'inline-block', fontFamily: 'inherit', fontSize: 'clamp(1.7rem, 4vw, 2.6rem)',
    fontWeight: 800, letterSpacing: '-0.04em', lineHeight: 1.2, color: '#183d58',
    maxWidth: '100%', overflowWrap: 'anywhere', verticalAlign: 'middle',
  }}>{branding.name}</span>;
}
